'use es6';

import { Route, Redirect, Switch } from 'react-router-dom';
import Application from './components/Application';
import Dashboard from './containers/Dashboard';
import AsyncStockImages from './components/codeSplitting/AsyncStockImages';
import { PathParams } from './Constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default /*#__PURE__*/_jsx(Route, {
  path: "/",
  render: props => /*#__PURE__*/_jsx(Application, Object.assign({}, props, {
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        exact: true,
        path: "/",
        component: Dashboard
      }), /*#__PURE__*/_jsx(Route, {
        path: PathParams.TRY_VIDEO,
        component: Dashboard
      }), /*#__PURE__*/_jsx(Route, {
        path: PathParams.HUBSPOT_VIDEO,
        component: Dashboard
      }), /*#__PURE__*/_jsx(Route, {
        path: PathParams.SEARCH,
        component: Dashboard
      }), /*#__PURE__*/_jsx(Route, {
        path: "/stock-images",
        component: AsyncStockImages
      }), /*#__PURE__*/_jsx(Route, {
        path: "*",
        render: () => /*#__PURE__*/_jsx(Redirect, {
          to: "/"
        })
      })]
    })
  }))
});